export default "__VITE_ASSET__CJKdOm1f__"